import {React, useState} from 'react';

import constants from "../../../constants.js"
import styles from './readonlytable.module.css'


const ReadOnlyTable = ({headers, tableKey, tableData, tableTitle, tableFooter}) => {

  return (
    <table className={styles.TableContainer}>
      <caption className={styles.TableTitle}><h3>{tableTitle}</h3></caption>
      <thead className={styles.HeaderRow}>
        <tr>
          {headers.map((header) => {
            return (
              <th
              className={styles.Header} 
              style={{fontWeight: "bold", textAlign:header.text}}
              id={header.value} 
              key={header.value}>
                {header.label}
              </th>
            )
          })}
        </tr>
      </thead>

      <tbody className={styles.Body}>
        {tableData.map((element, i) => {
          {/* Alternate color for every other row*/}
          const background = i%2 == 1 ? constants.colors.cplWhite : constants.colors.cplGray

          return (<tr className={styles.Row} style={{backgroundColor: background}} key={element[tableKey]}>
            {headers.map((item) => {
              return (
                <td className={styles.Cell} style={{textAlign:item.text}}key={`${element[tableKey]}-${item.value}`}>
                  {element[item.value]}
                </td>
              )
            })}
          </tr>)
        })}
      </tbody>
      <tfoot style={{backgroundColor: (tableData.length%2 == 1 ? constants.colors.cplWhite : constants.colors.cplGray)}}>
        <tr className={styles.Row}><td className={styles.Cell} colSpan={headers.length}>{tableFooter}</td></tr>
      </tfoot>

    </table>
  )
}

export default ReadOnlyTable;